import {useEffect, useState} from "react";
import eventService from "../../services/event.service";
import EventTypes from "../../models/EventTypes";
import React from "react";
import {MessageTypes} from "../../services/message.service";

const MessageComponent = () => {
  const [message, setMessage] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    return eventService.onEvent(EventTypes.Message, (data) => {
      setMessage(data);
      setVisible(true);
      const timeout = 3000;
      setTimeout(() => {
        setVisible(false);
      }, timeout);
      setTimeout(() => {
        setMessage(null);
      }, timeout + 500);
    });
  }, []);

  const icons = {
    [MessageTypes.Success]: "fa fa-check-circle",
    [MessageTypes.Error]: "",
  };

  return (
    <div className={ `message-component ${message ? message.type : ''} ${ visible ? 'visible' : ''}` }>
      <div className="message-wrapper">
        <i className={ `${message ? icons[message.type] : ''}` } />
        {message && message.message}
      </div>
    </div>
  );
};

export default MessageComponent;
